import Swiper from "swiper/bundle";
import "swiper/swiper-bundle.css";

export class TestimonialSlider {
  constructor() {
    this.initSlider();
  }

  initSlider() {
    new Swiper(".testimonials__slider", {
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
      },
      loop: true,
      spaceBetween: 80,
      navigation: {
        nextEl: ".testimonials__nav-next",
        prevEl: ".testimonials__nav-prev",
      },
    });
  }
}
